/**
 * Both apps used to ship an Angular service worker (removed in SL-1825) but never unregistered it,
 * so browsers that installed it keep serving assets from its Cache Storage indefinitely. Call this
 * from `main.ts` in production builds to unregister any lingering registration so those clients
 * fall back to fetching assets directly from CloudFront. `ngsw-worker.js` in this folder reaches
 * clients still stuck on an old cached bundle.
 */
export function unregisterServiceWorkers(serviceWorker: ServiceWorkerContainer | null = navigator.serviceWorker ?? null): void {
  if (!serviceWorker) {
    return;
  }
  serviceWorker.getRegistrations().then(registrations => {
    registrations.forEach(registration => registration.unregister());
  });
}
